import {filter} from 'rxjs/operators';
import {Component, OnInit} from '@angular/core';
import {SecurityService} from '../../../services/SecurityService';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';

@Component({
    selector: 'login',
    templateUrl: './LoginComponent.html',
    styleUrls: ['./LoginComponent.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {

  email = '';
  password = '';
  rememberMe = true;
  sessionExpired = false;

  isLoggingIn$: Observable<boolean>;
  isAuthenticated$: Observable<boolean>;
  errorMessage$: Observable<string>;

  constructor(private _securityService: SecurityService, private router: Router) {
    this.isLoggingIn$ = this._securityService.isLoggingIn$;
    this.isAuthenticated$ = this._securityService.isAuthenticated$;
    this.errorMessage$ = this._securityService.loginMessage$;
    // Set by the ApiTokenInterceptor when a 401 forces the redirect here.
    // Navigation state is only readable during the navigation that carried it
    // (with history.state as the fallback once the router has committed it),
    // so the banner naturally shows once and not on an ordinary /login visit.
    const navState = this.router.getCurrentNavigation()?.extras?.state ?? history.state;
    this.sessionExpired = navState?.sessionExpired === true;
  }


  ngOnInit(): void {
    if (environment.production) {
      this.logout();
    }
    this.errorMessage$.pipe(
      filter((message) => !!message))
      .subscribe(() => this.password = '');
  }

  login(): void {
    this._securityService.login(this.email, this.password, this.rememberMe)
      .subscribe(() => {
        const url = this._securityService.redirectUrl || '/app/clients';
        this._securityService.redirectUrl = '';
        this.router.navigate([url]).then();
      });
  }

  logout(): void {
    this._securityService.logout();
  }
}
